export default __webpack_public_path__ + "assets/images/paintedROIs-bb90ebd34b204aa16ebb672d01afff92.png";